import { consume, ContextType } from '@lit/context';
import { css, html, LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { contexts } from '../contexts.js';
import { PageOrganizationUsage } from '../page-organization-usage.js';
import { linkStyles } from './cssstyles.js';

@customElement('storage-warning-banner')
class StorageWarningBanner extends LitElement {

  @consume({ context: contexts.org, subscribe: true }) private _org?: ContextType<typeof contexts.org>;
  @consume({ context: contexts.billing, subscribe: true }) private _billing?: ContextType<typeof contexts.billing>;

  render() {
    const org = this._org;
    const sub = this._billing?.subscription;
    if (!org || !sub)
      return nothing;
    const storageLimitGB = sub.plan.storage;
    if (storageLimitGB === undefined)
      return nothing;
    const usedGB = sub.usedStorageBytes / 1000 / 1000 / 1000;
    const usageRatio = usedGB / storageLimitGB;
    if (usageRatio < 0.9)
      return nothing;
    const percentage = Math.round(usageRatio * 100);
    return html`
      <section>
        Organization <strong>${org.orgSlug}</strong> has used <strong>${percentage}%</strong> of its storage.
        <a href=${PageOrganizationUsage.url({ orgSlug: org.orgSlug })}>Usage</a>
      </section>
    `;
  }

  static styles = [linkStyles, css`
    section {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: var(--sl-spacing-2x-small);
      padding: var(--sl-spacing-2x-small);
      background-color: #ffc107;
    }

    a {
      text-decoration: underline;
    }
  `];
}
